//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import StreamsDrawerAssetFeedsSourceList from '@streams/components/StreamsDrawerAssetFeedsSourceList';
import StreamsDrawerAssetFeedsUpdateSourcesButton from '@streams/components/StreamsDrawerAssetFeedsUpdateSourcesButton';

export const StreamsDrawerAssetFeedsSetup: React.FunctionComponent = () => {
  return (
    <StreamSetupWrapper className='cu-mt-6 cu-mx-auto cu-text-center'>
      <div className='cu-text-subtitle cu-mb-1'>
        Media Sources
      </div>
      <div className='cu-text-body'>
        <div>Choose which sources you want to add media from.</div>
        <div>Next, you'll be able to filter these sources.</div>
      </div>
      <div className='cu-mt-5'>
        <StreamsDrawerAssetFeedsSourceList />
      </div>
      <div className='cu-d-flex cu-justify-content-center'>
        <StreamsDrawerAssetFeedsUpdateSourcesButton buttonText='Continue' className='cu-mt-4 cu-mx-auto'/>
      </div>
    </StreamSetupWrapper>
  );
};

const StreamSetupWrapper = styled.div`
  max-width: ${({theme}) => theme.wideMeasure};
`;

export default StreamsDrawerAssetFeedsSetup;
